// Copyright 2020 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { NewSnapshotDTO, SnapshotDTO, TimelineEntryDTO } from "datatypes/SoramaWebApi";
import { Api } from "libraries/WebApi/Api";
import { IWebRequestHandler } from "libraries/WebRequestHandler/IWebRequestHandler";
import { WorkflowModuleTimelineEvent } from "libraries/WorkflowFramework/WorkflowModule/WorkflowModuleTimeEvent";
import { ExportService } from "services/Export/ExportService";

@autoinject
export class TimelineEntriesRepository {
    constructor(
        private readonly webRequestHandler: IWebRequestHandler,
        private readonly exportService: ExportService
    ) {}

    public get(entryId: string): Promise<TimelineEntryDTO> {
        return this.webRequestHandler
            .createGetRequest<TimelineEntryDTO>(Api.timelineEntries + "/" + entryId)
            .send()
            .then((x) => x.content);
    }

    public getWorkflowModuleEntry(entryId: string): Promise<WorkflowModuleTimelineEvent> {
        return this.get(entryId).then((entry) => {
            return new WorkflowModuleTimelineEvent(entry, this, this.exportService);
        });
    }

    public getSnapshot(entryId: string): Promise<SnapshotDTO> {
        return this.webRequestHandler
            .createGetRequest<SnapshotDTO>(Api.timelineEntries + "/" + entryId + "/Snapshot")
            .send()
            .then((x) => x.content);
    }

    public updateHighlighted(entryId: string, highlighted = true): Promise<TimelineEntryDTO> {
        return this.webRequestHandler
            .createPutRequest<TimelineEntryDTO>(Api.timelineEntries + "/" + entryId + "/Highlighted", highlighted)
            .withValue()
            .send()
            .then((response) => {
                return response.content;
            });
    }

    public updateNotes(entryId: string, notes: string): Promise<TimelineEntryDTO> {
        return this.webRequestHandler
            .createPutRequest<TimelineEntryDTO>(Api.timelineEntries + "/" + entryId + "/Notes", notes)
            .withValue()
            .send()
            .then((response) => {
                return response.content;
            });
    }

    public updateSnapshot(entryId: string, snapshot: string): Promise<TimelineEntryDTO> {
        return this.webRequestHandler
            .createPutRequest<TimelineEntryDTO>(Api.timelineEntries + "/" + entryId + "/Snapshot", <NewSnapshotDTO>{
                data: snapshot,
            })
            .send()
            .then((response) => {
                return response.content;
            });
    }

    public deleteSnapshot(entryId: string): Promise<void> {
        return this.webRequestHandler
            .createDeleteRequest(Api.timelineEntries + "/" + entryId)
            .send()
            .then(() => {});
    }
}
